import { EditorObject } from '../models/editor-object.model';
import { InteriorObject } from '../models/interior-object.model';
import { CloneService } from '../services/clone.service';
import { BaseDimensionComponent } from '../models/components/commonComponents/BaseDimensionComponent';
import { Box } from '../models/other/box.model';

export function mapInteriorObjectFromEditorObject(ed: EditorObject): InteriorObject {
    const cloneService = new CloneService();
    let interiorO = new InteriorObject();
    interiorO.components = cloneService.deepClone(ed.components);
    let baseDim = new BaseDimensionComponent();
    
    baseDim.posX = Math.round(ed.x());
    baseDim.posY = Math.round(ed.y());
    baseDim.box = new Box();
    baseDim.box.width = ed.width();
    baseDim.box.length = ed.height();
    baseDim.box.height = ed.height3D;
    baseDim.rotation = ed.rotation();

    interiorO.components.push(baseDim);

    return interiorO;
}